import _                        from 'underscore';
import React, { FC, ReactNode } from 'react';
import { Container, Icon }      from 'semantic-ui-react';
import { Link }                 from 'react-router-dom';
import { Cell, Grid }           from 'styled-css-grid';

import { CorvalUIColor, Position, Size } from '../../types';
import { StyledContainer }               from './StyledContainer';
import { zipArraysOddEven }              from '../../util';
import { PAGE }                          from '../../constants/UIEnums';

type BreadcrumbItem = { label: string | ReactNode, link: string }

interface Props {
	items: BreadcrumbItem[],
	activeIndex?: number,
	enabled?: boolean,
}

const defaultProps: Props = {
	items:       null,
	activeIndex: null,
	enabled:     true,
}

const Breadcrumb: FC<Props> = ( props ) => {
	
	if( !props.enabled || !props.items || props.items.length === 0 ) return null;
	
	let { items, activeIndex } = props;
	let columnCount            = ( items.length * 2 ) - 1;
	
	let isActive = ( index ) => {
		
		return ( activeIndex === index )
	}
	
	/* Creates cells with links inside */
	let generatedLinks = items.map( ( item, index ) => (
		<Cell key={ `link-${ index }` }>
			{ isActive( index )
			  ? <>{ item.label }</>
			  : <Link to={ item.link }><strong>{ item.label }</strong></Link> }
		
		</Cell>
	) )
	
	/* Creates cells with filler icon inside */
	let generateFillers = _.range( items.length - 1 ).map( ( n, index ) => (
		<Cell key={ `filler-${ index }` }>
			<Icon size={ 'small' } name={ 'angle right' } color={ 'grey' } fitted/>
		</Cell>
	) )
	
	/* Create one output array alternating links and filler cells */
	let renderItems = zipArraysOddEven( generatedLinks, generateFillers );
	
	return (
		
		<StyledContainer position={ Position.STICKY } top={ 0 }
		                 bgColor={ CorvalUIColor.WHITE }
		                 zIndex={ 200 }
		                 padding={ [ Size.SM, null ] }
		                 className={ 'text--sm' }
		                 style={ {
			                 boxShadow:  '0px 3px 20px rgba(0,0,0,0.05)',
			                 boxSizing:  'border-box',
			                 display:    'flex',
			                 alignItems: 'center',
			                 maxHeight:  PAGE.BREADCRUMB_HEIGHT,
		                 } }>
			<Container>
				<Grid columns={ ( columnCount > 1 ) ? `repeat(${ columnCount - 1 }, auto) 1fr` : `1fr` }>
					
					{ renderItems }
				
				</Grid>
			</Container>
		</StyledContainer>
	);
};

Breadcrumb.defaultProps = defaultProps;

export { Breadcrumb }
